import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SESSION_STORAGE, StorageService, User } from '@phdsoft/common';
import { IWindow } from '@phdsoft/window';
import { MessageService } from 'primeng/api';
import { SectionItem } from 'projects/phdsoft/common/src/lib/models/sectionitem-info.model';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { Observable } from 'rxjs';
import { AssetFilesService } from 'src/app/admin/services/asset-files.service';
import { RegionsService } from 'src/app/admin/services/regions.service';
import { SectionsService } from 'src/app/admin/services/sections.service';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { DigitalTwinService } from 'src/app/digital-twin/digital-twin.service';
import { Section } from 'src/app/platform/busines-data/Framework/Section';
import { LinearElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/LinearElement';
import { SurfaceElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/SurfaceElement';
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement';
import { Vector3 } from 'three';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'phdsoft-create-new-section-config',
  templateUrl: "./create-new-section-config.component.html",
  styleUrls: ["./create-new-section-config.component.scss"]
})
export class CreateNewSectionConfigComponent {

  public optionsWindow: IWindow = {
    Position: 'favorite',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'New User',
      Visible: true,
    },
    Footer: {
      ShowCancel: false,
      ShowOk: true,
      Visible: true,
    },
  };


  private _fullIdsElements : Array<WorkableElement>;
  public get completedIdsElements() : Array<WorkableElement> {
    return this._fullIdsElements;
  }
  public set completedIdsElements(v : Array<WorkableElement>) {
    this._fullIdsElements = v;
  }
  sectionName: string = '';

  private _width: number = 1;
  private _height: number = 1;
  private _depth: number = 1;

  public get width(){
    return this._width
  }
  public set width(v: number){
    this._width = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get height(){
    return this._height
  }
  public set height(v: number){
    this._height = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get depth(){
    return this._depth
  }
  public set depth(v: number){
    this._depth = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }


  public get formatedWidth(){
    return (this.width * 100).toFixed(0)
  }

  public get formatedHeight(){
    return (this.height * 100).toFixed(0)
  }

  public get formatedDepth(){
    return (this.depth * 100).toFixed(0)
  }

  public get dimensions(){
    return new Vector3(this.width, this.height, this.depth)
  }


  constructor(
    public dialogRef: MatDialogRef<CreateNewSectionConfigComponent>,
    private assetManager: AssetManager,
    private readonly digitalTwinService: DigitalTwinService,
    private regionService: RegionsService,
    private sectionService: SectionsService,
    private readonly assetFilesService: AssetFilesService,
    private messageService: MessageService,
    private storageService: StorageService,
    private readonly regionsService: RegionsService,
    private snackBar: MatSnackBar,
  ) {}

  updateBoxDimensions(){
    this.assetManager.updateCriticalAreaBox(this.width, this.height, this.depth)
  }

  submit(){
    this.dialogRef.close()
  }

  onSelectElementFullId() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'SECTIONCREATIONELEMENTS';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }
  onSelectFullIdTarget() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'FULLIDSELEMENTTARGET';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }

  onTargetSelectButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'INSPECCHANGETARGET';
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onTargetSelectButtonClick button clicked!');
  }

  onExecuteChangeButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.setNewSection();
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onExecuteChangeButtonClick button clicked! CompletedIds');
  }

  save() {
    this.saveCompletedIds();

    console.log('onStopInspectionChangeButtonClick button clicked!');
  }

  cancel() {
    if(this.assetManager.newSectionElements){
      for (const element of this.assetManager.newSectionElements) {
        element.currentRenderMaterial = element.defaultMaterial;
      }
    }

    this.assetManager.newSectionElements = []

    this.files = null;
    this.newSectionId = null
    this.oldSectionId = null
    this.regionsIds = []
    this.user = null
    this.assetManager.setFunctionalityModeNone();
  }


  public async setNewSection(){
    debugger
    console.log(this.assetManager.fullIdElementTarget)
    console.log(this.assetManager.fullIdsElements)
    this.files = []
    if(this.assetManager.newSectionElements){
      this.newSectionId = uuid() as string;
      this.regionsIds = []
      const blobPath = this.assetManager.asset.assetInfo.Collections[0].BlobPaths.find(item => item.RegionId == this.assetManager.currentRegion.Guid);
      if (blobPath){
        let dataFile = await this.regionService.getFileRegion(blobPath.DefaultGeoPath);
        let ids = []
        for (const element of this.assetManager.newSectionElements) {
          this.oldSectionId = element.properties.SectionId
          element.properties.SectionId = this.newSectionId;
          let index = dataFile.findIndex(x => x.ElementId === element.properties.ElementId)
          if(index > -1){
            dataFile[index].SectionId = this.newSectionId;
          }
          ids.push(...element.regionIds);
        }

        var r = new Set(ids);
        this.regionsIds = []
        for (const element of r) {
          this.regionsIds.push(element)
        }

        const file = new File([new Blob([JSON.stringify(dataFile)], { type: 'text/plain' })], this.assetManager.getCurrentRegionId() + ".json");
        this.files.push(file);
        // this.dataFile = dataFile
      }
      this.messageService.add({ severity: 'success', summary: 'Setting new section data on local', detail: 'Success', life: 3000 });
      this.snackBar.open('Setting new section data on local', '', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration:6000
      });
      console.log("Setting new section data on local")
    }
  }
  private files = null;
  private newSectionId = null
  private oldSectionId = null
  private regionsIds = []
  private user = null
  public async saveCompletedIds(){
    debugger
    if(this.assetManager.newSectionElements && this.assetManager.newSectionElements.length > 0){
      console.log(this.regionsIds)
      for (const regionId of this.regionsIds) {
        var regionsItens = await this.regionsService.getRegionsFromBackend(this.assetManager.asset.assetInfo.AssetId).toPromise();
        let regionItem = regionsItens.find(x => x.id == regionId);
        let index = regionItem.sections.findIndex(x => x === this.newSectionId);
        let sections = await this.sectionService.getSectionsFromMicroservice(this.assetManager.asset.assetInfo.AssetId).toPromise();
        let oldSection:SectionItem = sections.find(x => x.id === this.oldSectionId);

        if(oldSection){
          let newSection: SectionItem= JSON.parse(JSON.stringify(oldSection));

          newSection.id = this.newSectionId;
          newSection.properties.General.SectionId = this.newSectionId
          newSection.properties.General.Name = this.sectionName
          newSection.properties.SectionId = this.newSectionId
          newSection.regions = [regionId];
          newSection.name = this.sectionName

          await this.sectionService.post([newSection], this.assetManager.asset.assetInfo.AssetId).toPromise();
        }
        if(index === -1){
          regionItem.sections.push(this.newSectionId);
        }

        await this.regionsService.post([regionItem], this.assetManager.asset.assetInfo.AssetId).toPromise();
      }

      this.user = await this.storageService.getItem<User>(
        SESSION_STORAGE.USER,
      )
      await this.digitalTwinService.updatePropertiesList(this.assetManager.newSectionElements.map(x => x.properties), this.assetManager.newSectionElements[0].regionId, this.assetManager.asset.assetInfo.AssetId);


      let collectionInfo = {
        AssetId: this.assetManager.asset.assetInfo.AssetId,
        CollectionId: this.assetManager.asset.assetInfo.Collections[0]?.CollectionId ?? null,
        Success: false,
        // regionId: null
      };
      let formData: FormData = new FormData();
      formData.append('collectionInfo', JSON.stringify(collectionInfo));
      this.files.forEach(file => {
        formData.append('formFiles', file);
      });

      const observables: Observable<any>[] = [];

      const filesArray: File[] = []
      this.files.forEach( file => {
        filesArray.push(file)
      });


      this.assetFilesService.postGeometries(formData).subscribe(
        {complete: () => {
          this.messageService.add({ severity: 'success', summary: 'Sending files to server...', detail: 'Success', life: 3000 });

          this.digitalTwinService.postJsonFilesToGltf(filesArray, this.assetManager.asset.assetInfo.AssetId, collectionInfo.CollectionId, this.user.id)
          .subscribe(async (result) => {
          this.messageService.add({ severity: 'success', summary: 'Import Geometries For GlTF', detail: 'Files imported', life: 10000 });

          this.setNewSectionOnRender();
          this.cancel();

        },
          (error) => {
            this.messageService.add({ severity: 'error', summary: 'Import Geometries Failed', detail: error.message, life: 10000 })
            this.cancel();

            // this.loading = false
          },
          () => {
            this.cancel();
            // this.loading = false
            // this.geometryForGlftFileUpload.nativeElement.value = null
          }
        );
          // this.loading = false
        },
        error: (err: any) => {
          this.cancel();
          console.log(err)
        }
      })


    }
    // this._completedIdsElements = []
  }

  private setNewSectionOnRender(){
    let region = this.assetManager.asset.StructureCampaigns[0].regionsWorkableElements.find(x => x.Guid === this.regionsIds[0]);
    const section = new Section(this.newSectionId, this.sectionName);
    section.isStructureSection = true;
    region.addSection(section);

    for (const element of this.assetManager.newSectionElements) {
      if(element instanceof SurfaceElement){
        region.addSurfaceElement(element);
      }
      else if (element instanceof LinearElement){
        region.addLinearElement(element);
      }
    }
  }
}

